// PoolScreener core — shared types. Pure computation layer: no I/O, no
// React. Every screen returns the same shape so the UI can render them
// uniformly and the orchestrator can score them.

export type Verdict = 'PASS' | 'FAIL' | 'WARN' | 'INSUFFICIENT_DATA';

/** The result of one screen. `value` is the screen's headline number (its
 *  meaning is screen-specific — coverage ratio, IV/RV ratio, funding APR,
 *  …); `detail` carries every intermediate so the pool drawer can audit it. */
export interface ScreenResult {
  value: number;
  verdict: Verdict;
  detail: Record<string, number>;
}

/** Minimum daily samples we require before trusting a stdev/vol estimate.
 *  Below this a screen returns INSUFFICIENT_DATA rather than a noisy number. */
export const MIN_DAILY_SAMPLES = 10;

/** Binance perp funding settles every 8h → 3 intervals/day. Used to
 *  annualize a per-interval funding rate. */
export const FUNDING_INTERVALS_PER_YEAR = 3 * 365;

export const TRADING_DAYS_PER_YEAR = 365;
